import { AnyDocument } from '../../../types';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentSelectorQueryKey = <DocumentType extends AnyDocument>(
  documentId: DocumentType['id'],
  documentParams: DocumentParams,
  selector: string | undefined,
) => [DOCUMENTS_BASE_PATH, documentId, documentParams, 'selector', selector];
